import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { getAllDropdownBySubTypeId, getCategory2BasedOnCategory, getCategoryTypeBasedOnCategory, getEqClassCodeExample, getEquipmentModelsBasedOnMake, getModelsBasedOnMake, setCategory2BasedOnCategory, setCategoryTypeBasedOnCategory, setEqClassCodeExample, setModelsBasedOnMake, validateSelectedVehicleLevels } from "Store/Component/CatalogManagement/CatalogManagementAction";
import { formatPrice, sanitizeE1Input } from "utils";
import AssetType from "./AssetType";
import { CONSTANTS } from "client/utils/constants";

const initialCatalogValues = {
    vehicleType: '',
    vehicleLevel: [],
    make: '',
    model: '',
    year: '',
    noOfDoors: '',
    truckSize: '',
    bvSpec: '',
    upfit: '',
    eqClassCode: '',
    driveTrain: '',
    fuelType: '',
    catalogDescription: '',
    eOneDescription: '',
    detailedDescription: '',
    poDescription1: '',
    poDescription2: '',
    actualPrice: '',
    budgetingPercent: { label: '10%', value: "10" },
    budgetingPrice: '',
    leaseTerm: '',
    monthlyDeprecation: '',
    logoed: '',
    use: '',
    groupType: '',
    cdl: '',
    trim: '',
    vehicleClass: '',
    vehicleGrossWeightRating: '',
    classType: ''
}

const AssetTypeContainer = (props: any) => {

    const [showEqClassCodeListModal, setShowEqClassCodeListModel] = useState(false)

    const {
        selectedAssetType,
        assetTypeValue,
        catalogItemValues,
        setCatalogItemValues,
        capacityList,
        noOfDoorsList,
        makeList,
        modelsList,
        upfitOptionList,
        driveTrainList,
        snowSetupList,
        powerTypeList,
        eqClassCodeList,
        vehicleLevelList,
        yearList,
        categoryList,
        catalogItemErrors,
        validateCatalogItemValues,
        vehicleTypeDropdown,
        sizeList,
        lengthList,
        seatingCapacityList,
        enclosedCabList,
        classTypeList,
        groupTypeList,
        cdlList,
        grossWeightList,
        vehicleClassList,
        trimList,
        category2List,
        categoryTypeList,
        constructionEquipmentWithSubCategory,
        standardizedEquipmentWithSubCategory,
        snowWithSubCategory,
        ExistingDropDownValue,
        handleClickAddModel,
        typeList,
        editFilterModel,
        setCatalogItemErrors
    } = props

    const dispatch = useDispatch()

    const vehicleTypeOption = useMemo(() => {
        return vehicleTypeDropdown?.filter((vehicle: any) => vehicle?.orderRequestTypeId === 1)?.map((vehicle: any) => ({ ...vehicle, value: vehicle.orderRequestSubTypeId, label: vehicle.orderRequestType }))
    }, [vehicleTypeDropdown])

    
    const handleClickShowEqClassCodeList = () => {
        if (showEqClassCodeListModal) {
            setShowEqClassCodeListModel(false)
            dispatch(setEqClassCodeExample([]))
        } else {
            setShowEqClassCodeListModel(true)
            //currently getting examples irrespective of subType, this is just a provision for future
            dispatch(getEqClassCodeExample(1))
        }
    }

    const handleOnChange = (value: any, name: string) => {
        // Sanitize E1 fields
        if (name === 'eOneDescription' || name === 'poDescription1' || name === 'poDescription2') {
            value = sanitizeE1Input(value);
        }
        
        if (name === 'vehicleType') {
            dispatch(getAllDropdownBySubTypeId(selectedAssetType?.assetType?.id, selectedAssetType?.assetType?.value === CONSTANTS.VEHICLE));
            if(value?.label == "Management Vehicle"){
                let val = upfitOptionList?.find((item?: any) => item?.label == "None")
                setCatalogItemValues({ ...catalogItemValues, ...initialCatalogValues, [name]: value, upfit: val})
            } else {
            setCatalogItemValues({ ...catalogItemValues, ...initialCatalogValues, [name]: value, upfit: ''})
            }
            setCatalogItemErrors({})
            validateCatalogItemValues(value, name)
        } else {
            setCatalogItemValues((prev: any) => ({ ...prev, [name]: value }))
            validateCatalogItemValues(value, name)
        }

        if (name === 'make' && assetTypeValue === CONSTANTS.VEHICLE) {
            if (value?.value) {
                setCatalogItemValues((prev: any) => ({ ...prev, model: '' }))
                dispatch(setModelsBasedOnMake([]))
                dispatch(getModelsBasedOnMake(value?.value, catalogItemValues?.vehicleType?.label))
            } else {
                setCatalogItemValues((prev: any) => ({ ...prev, model: '' }))
                dispatch(setModelsBasedOnMake([]))
            }
        } else if (name === 'make' || name === 'manufacturer') {
            if (value?.value) {
                setCatalogItemValues((prev: any) => ({ ...prev, model: '' }))
                dispatch(setModelsBasedOnMake([]))
                dispatch(getEquipmentModelsBasedOnMake(value?.value, assetTypeValue))
            } else {
                setCatalogItemValues((prev: any) => ({ ...prev, model: '' }))
                dispatch(setModelsBasedOnMake([]))
            }
        }

        if (name === 'category' && 
        (assetTypeValue === CONSTANTS.CONSTRUCTION_EQUIPMENT || assetTypeValue === CONSTANTS.STANDARIZED_EQUIPMENT) &&
        (constructionEquipmentWithSubCategory.includes(value.label || '') || standardizedEquipmentWithSubCategory.includes(value.label || ''))
        ) {
            setCatalogItemValues((prev: any) => ({ ...prev, category2: '' }))
            dispatch(setCategory2BasedOnCategory([]))
            dispatch(getCategory2BasedOnCategory(value?.value))
        } else if(name === 'category' && 
        (assetTypeValue === CONSTANTS.CONSTRUCTION_EQUIPMENT || assetTypeValue === CONSTANTS.STANDARIZED_EQUIPMENT) &&
        !(constructionEquipmentWithSubCategory.includes(value.label || '') || standardizedEquipmentWithSubCategory.includes(value.label || ''))){
            setCatalogItemValues((prev: any) => ({ ...prev, category2: '' }))
            dispatch(setCategory2BasedOnCategory([]))
        }
        
        if(name === 'category' && assetTypeValue === CONSTANTS.SNOW && [CONSTANTS.SNOW_CATEGORY.PLOW].includes(value.label || '')){
            setCatalogItemValues((prev: any) => ({ ...prev, categoryType: '' }))
            dispatch(setCategoryTypeBasedOnCategory([]))
            dispatch(getCategoryTypeBasedOnCategory(value?.value))
        } else if(name === 'category' && assetTypeValue === CONSTANTS.SNOW && ![CONSTANTS.SNOW_CATEGORY.PLOW].includes(value.label || '')) {
            setCatalogItemValues((prev: any) => ({ ...prev, categoryType: '' }))
            dispatch(setCategoryTypeBasedOnCategory([]))
        }

        if(name === 'vehicleLevel'){
            const levelId = value?.map((level: any)=>level.value)?.join(",")
            dispatch(validateSelectedVehicleLevels(levelId))
        }
    }

    const priceFormat = (e: any, name: string) => {
        if (e.target.value == 0) {
            return
        }
        setCatalogItemValues((prev: any) => ({ ...prev, [name]: formatPrice(e.target.value, 2) }));
    };

    const isUtilityOrConstructionEquipment = (assetTypeValue === CONSTANTS.UTILITY_VEHICLE || assetTypeValue === CONSTANTS.CONSTRUCTION_EQUIPMENT)

    return (
        <AssetType
            vehicleTypeOption={vehicleTypeOption}
            vehicleLevelOption={vehicleLevelList}
            doorsOption={noOfDoorsList}
            capacityOption={capacityList}
            assetTypeValue={assetTypeValue}
            makeOption={makeList}
            modelOption={modelsList}
            categoryOption={categoryList}
            yearOption={yearList}
            upfitOption={upfitOptionList}
            eqClassCodeOption={eqClassCodeList}
            driveTrainOption={driveTrainList}
            powerTypeOption={powerTypeList}
            handleClickAddModel={handleClickAddModel}
            selectedAssetType={selectedAssetType}
            catalogItemValues={catalogItemValues}
            handleOnChange={handleOnChange}
            catalogItemErrors={catalogItemErrors}
            priceFormat={priceFormat}
            sizeOption={sizeList}
            lengthOption={lengthList}
            seatingCapacityOption={seatingCapacityList}
            enclosedCabOption={enclosedCabList}
            isUtilityOrConstructionEquipment={isUtilityOrConstructionEquipment}
            classTypeOption={classTypeList}
            groupTypeOption={groupTypeList}
            vehicleClassOption={vehicleClassList}
            vehicleGrossWeightOption={grossWeightList}
            cdlOption={cdlList}
            trimOption={trimList}
            category2Option={category2List}
            categoryTypeOption={categoryTypeList}
            constructionEquipmentWithSubCategory={constructionEquipmentWithSubCategory}
            standardizedEquipmentWithSubCategory={standardizedEquipmentWithSubCategory}
            snowWithSubCategory={snowWithSubCategory}
            snowSetupOption={snowSetupList}
            filterName={props.filterName}
            setFilterName={props.setFilterName}
            filterModelPopup={props.filterModelPopup}
            onPopupFilterModel={props.onPopupFilterModel}
            setFilterModelPopup={props.setFilterModelPopup}
            ExistingDropDownValue = {ExistingDropDownValue}
            typeList={typeList}
            handleClickShowEqClassCodeList={handleClickShowEqClassCodeList}
            showEqClassCodeListModal={showEqClassCodeListModal}
            setShowEqClassCodeListModel={setShowEqClassCodeListModel}
            editFilterModel = {editFilterModel}
        />
    )
}

export default AssetTypeContainer;